module.exports = __webpack_public_path__ + "img/sample-03.24dacc0e.png";